<template>
    <div class="member-tags-page">
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-collection-tag"></i> 会员标签管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container">
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input v-model="name" placeholder="请输入会员标签编号" class="handle-input mr10" clearable @clear="handleSearch"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="margin-left:auto" icon="el-icon-refresh" plain @click="handleRefresh">{{ $t('common.refresh') }}</el-button>
                <el-button type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}</el-button>
            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable" header-cell-class-name="table-header">
                <!-- 序号列 -->
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <!-- 标签编号列 -->
                <el-table-column prop="tags_no" label="会员标签编号" min-width="130" align="center"></el-table-column>
                <!-- 标签名称列 -->
                <el-table-column prop="tags_name" label="会员标签名称" min-width="130" align="center"></el-table-column>
                <!-- 标签颜色列 -->
                <el-table-column label="标签颜色" min-width="120" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.tags_color" class="color-tag" :style="{ backgroundColor: scope.row.tags_color }">
                            {{ scope.row.tags_name }}
                        </span>
                        <span v-else class="color-tag color-tag--default">{{ scope.row.tags_name }}</span>
                    </template>
                </el-table-column>
                <!-- 门店列（多门店模式下显示） -->
                <el-table-column v-if="systemSet.isstores == 1" prop="store_no" label="所属门店编号" min-width="130" align="center"></el-table-column>
                <el-table-column v-if="systemSet.isstores == 1" prop="store_name" label="所属门店名称" min-width="130" align="center"></el-table-column>
                <!-- 启用状态列 -->
                <el-table-column label="启用" width="80" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="handleStatusChange(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <!-- 默认状态列 -->
                <el-table-column label="默认" width="80" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isdefault" :active-value="1" :inactive-value="0" @change="handleStatusChange(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <!-- 备注列 -->
                <el-table-column prop="remark" :label="$t('common.remark')" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                <!-- 操作列 -->
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)" v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                        <el-button size="mini" type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30, 50]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 新增/编辑对话框（共用） -->
        <el-dialog :title="isEdit ? '编辑会员标签' : '新增会员标签'" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="formRules" label-width="110px" class="dialog-form">
                <!-- 标签编号（编辑时不可修改） -->
                <el-form-item label="会员标签编号" prop="tags_no">
                    <el-input v-model="form.tags_no" :disabled="isEdit" placeholder="请输入标签编号"></el-input>
                </el-form-item>
                <!-- 标签名称 -->
                <el-form-item label="会员标签名称" prop="tags_name">
                    <el-input v-model="form.tags_name" placeholder="请输入标签名称"></el-input>
                </el-form-item>
                <!-- 标签颜色 -->
                <el-form-item label="标签颜色" prop="tags_color">
                    <div class="color-picker-row">
                        <el-color-picker v-model="form.tags_color" :predefine="predefineColors" size="medium"></el-color-picker>
                        <span class="color-preview-text" v-if="form.tags_color">{{ form.tags_color }}</span>
                        <span class="color-preview-text color-preview-text--empty" v-else>未选择（使用默认颜色）</span>
                    </div>
                    <!-- 颜色预览 -->
                    <div class="color-preview" v-if="form.tags_name">
                        <span class="color-tag" :style="form.tags_color ? { backgroundColor: form.tags_color } : {}" :class="{ 'color-tag--default': !form.tags_color }">
                            {{ form.tags_name }}
                        </span>
                    </div>
                </el-form-item>
                <!-- 所属门店（多门店模式下显示） -->
                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                    <el-select v-model="form.store_no" clearable filterable default-first-option placeholder="请选择门店" class="full-width">
                        <el-option v-for="(item, index) in pullData.store" :key="index" :label="item.store_name" :value="item.store_no">
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 备注 -->
                <el-form-item :label="$t('common.remark')" prop="remark">
                    <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 导入会员标签管理相关 API 接口
import {
    apiGetMemberTagsStatusList,
    apiCurrentPermisson,
    apiMemberTagsManagePull,
    apiAddMemberTagsData,
    apiUpdateMemberTagsStatus,
    apiUpdateMemberTagsData,
    apiDeleteMemberTagsData
} from '@/request/api';

export default {
    name: 'memberTagsManage',
    data() {
        return {
            // 表单数据（新增/编辑共用）
            form: {},
            // 是否为编辑模式
            isEdit: false,
            // 对话框显示状态
            dialogVisible: false,
            // 提交按钮加载状态
            submitLoading: false,
            // 下拉数据源（门店等）
            pullData: {},
            // 搜索关键字
            name: '',
            // 分页参数
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            // 表格数据
            tableData: [],
            // 按钮权限数据
            perData: {},
            // 系统设置（是否多门店等）
            systemSet: JSON.parse(localStorage.getItem('systemSet')),
            // 预设快捷颜色
            predefineColors: [
                '#409EFF', // 主题蓝
                '#67C23A', // 成功绿
                '#E6A23C', // 警告橙
                '#F56C6C', // 危险红
                '#909399', // 信息灰
                '#9B59B6', // 紫色
                '#1ABC9C', // 青色
                '#E91E63', // 玫红
                '#FF9800', // 橙色
                '#795548'  // 棕色
            ],
            // 表单校验规则
            formRules: {
                tags_no: [
                    { required: true, message: '请输入会员标签编号', trigger: 'blur' }
                ],
                tags_name: [
                    { required: true, message: '请输入会员标签名称', trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        // 组件挂载时初始化数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    activated() {
        // keep-alive 缓存组件激活时刷新数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    methods: {
        // ==================== 数据加载 ====================
        // 获取下拉数据源（门店列表等）
        getPull() {
            apiMemberTagsManagePull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        // 获取标签列表数据
        getData() {
            this.$load.show();
            apiGetMemberTagsStatusList({
                page: this.pageIndex,       // 当前页码
                page_size: this.pageSize,   // 每页数量
                seek: this.name             // 搜索关键字
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.data.msg);
                }
            }).finally(() => {
                this.$load.close();
            });
        },
        // 获取当前页面按钮权限（新增、编辑、删除）
        getPermission() {
            apiCurrentPermisson({
                id: '221' // 会员标签管理权限ID
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // ==================== 搜索与分页 ====================
        // 搜索按钮点击事件
        handleSearch() {
            this.pageIndex = 1; // 重置为第一页
            this.getData();
        },
        // 刷新按钮点击事件
        handleRefresh() {
            this.getPull();
            this.getData();
        },
        // 页码变化事件
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        // 每页数量变化事件
        pageSizeChange(val) {
            this.pageSize = val;
            this.getData();
        },

        // ==================== 新增/编辑 ====================
        // 打开新增对话框
        handleAdd() {
            this.isEdit = false;
            this.dialogVisible = true;
            this.form = {
                tags_no: '',
                tags_name: '',
                tags_color: '#409EFF', // 默认主题蓝色
                store_no: '',
                remark: ''
            };
            this.$nextTick(() => {
                // 清除校验状态
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
                // 自动选择默认门店
                if (this.pullData.store) {
                    const defaultStore = this.pullData.store.find((store) => store.isdefault == 1);
                    this.$set(this.form, 'store_no', defaultStore ? defaultStore.store_no : '');
                }
            });
        },
        // 打开编辑对话框
        handleEdit(row) {
            this.isEdit = true;
            this.dialogVisible = true;
            // 深拷贝行数据，避免直接修改表格原始数据
            this.form = JSON.parse(JSON.stringify(row));
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },
        // 提交表单（新增/编辑共用）
        submitForm() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.submitLoading = true;
                const formData = { ...this.form };
                // 根据模式调用不同接口
                const apiCall = this.isEdit ? apiUpdateMemberTagsData(formData) : apiAddMemberTagsData(formData);
                apiCall.then(res => {
                    if (res.code == 2000) {
                        this.$message.success(this.isEdit ? res.msg : '添加成功');
                        this.dialogVisible = false;
                        this.getData(); // 刷新表格数据
                    } else {
                        this.$message.error(res.data.info);
                    }
                }).finally(() => {
                    this.submitLoading = false;
                });
            });
        },
        // 关闭对话框并重置表单
        handleClose() {
            this.form = {};
            this.dialogVisible = false;
        },

        // ==================== 删除 ====================
        // 删除标签（二次确认）
        handleDelete(row) {
            this.$confirm('确定要删除该会员标签吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                apiDeleteMemberTagsData({ tags_no: row.tags_no }).then(res => {
                    if (res.code == 2000) {
                        this.$message.success('删除成功');
                        this.getData(); // 刷新表格数据
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }).catch(() => {});
        },

        // ==================== 状态切换 ====================
        // 启用/默认状态切换事件
        handleStatusChange(row) {
            const data = {
                tags_no: row.tags_no,       // 会员标签编号
                store_no: row.store_no,     // 门店编号
                islock: row.islock,         // 锁定状态
                status: row.status,         // 启用状态（1=启用，0=停用）
                isdefault: row.isdefault    // 默认状态（1=是，0=否）
            };
            apiUpdateMemberTagsStatus(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.data.info);
                }
                this.getData(); // 刷新表格数据
            });
        }
    }
};
</script>

<style scoped>
/* 搜索区域 */
.member-tags-page .handle-box {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}
.member-tags-page .handle-input {
    width: 300px;
}
.member-tags-page .mr10 {
    margin-right: 10px;
}
/* 表格 */
.member-tags-page .table {
    width: 100%;
    font-size: 14px;
    border-radius: 4px;
}
/* 颜色标签样式 */
.member-tags-page .color-tag {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 未设置颜色时的默认样式 */
.member-tags-page .color-tag--default {
    background-color: #909399;
}
/* 颜色选择器行 */
.member-tags-page .color-picker-row {
    display: flex;
    align-items: center;
}
.member-tags-page .color-preview-text {
    margin-left: 10px;
    font-size: 13px;
    color: #606266;
}
.member-tags-page .color-preview-text--empty {
    color: #c0c4cc;
}
/* 颜色预览区域 */
.member-tags-page .color-preview {
    margin-top: 8px;
}
/* 分页 */
.member-tags-page .pagination {
    margin-top: 20px;
    text-align: right;
}
/* 对话框表单 */
.member-tags-page .dialog-form {
    padding: 0 10px;
}
.member-tags-page .full-width {
    width: 100%;
}
</style>
<style>
/* 表格表头样式 */
.member-tags-page .el-table thead {
    color: #303133;
    font-weight: 600;
}
.member-tags-page .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #fafafa;
}
.member-tags-page .el-table th {
    background: #f5f7fa !important;
}
/* 对话框头部/底部分隔线 */
.member-tags-page .el-dialog__header {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 15px;
}
.member-tags-page .el-dialog__footer {
    border-top: 1px solid #ebeef5;
    padding-top: 15px;
}
/* 移动端适配 */
@media screen and (max-width: 768px) {
    .member-tags-page .el-dialog {
        width: 100% !important;
    }
    .member-tags-page .el-message-box {
        width: 100%;
    }
    .member-tags-page .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
